import type { ParseKeys } from 'i18next';

export class ViewName {
  public readonly value: string;

  public constructor(value: string) {
    this.value = value;
  }

  public static load(name: string): ViewName {
    return new ViewName(name);
  }

  public trim(): ViewName {
    return new ViewName(this.value.trim());
  }

  public isEquals(other: ViewName): boolean {
    return other instanceof ViewName && other.value == this.value;
  }

  public buildCopyName(): ViewName {
    if (this.value == '') {
      return new ViewName(this.value);
    }

    return new ViewName(`${this.value} のコピー`);
  }

  /**
   * コピー名の翻訳キーと補間変数を返します。
   * 呼び出し側で t(key, params) を呼んでください。
   */
  public buildCopyNameKey(): { key: ParseKeys; params: { name: string } } | null {
    if (this.value == '') {
      return null;
    }

    return { key: 'common.label.copyName', params: { name: this.value } };
  }

  public toReadableName(): string {
    return this.value == '' ? '名称未設定のビュー' : this.value;
  }

  /**
   * 読み取り可能な名前の翻訳キーを返します。
   * 名前が空の場合のみ翻訳キーを返し、値がある場合は null を返します。
   * 呼び出し側で t(key) または value を使ってください。
   */
  public toReadableNameKey(): ParseKeys | null {
    return this.value == '' ? 'canvas.view.untitled' : null;
  }
}
